export default "__VITE_ASSET__6ea052d8__"